// Form validation rules shared by the staff review and PDF views.
import { required, helpers } from "@vuelidate/validators";

export const staffReviewValidations = {
  form: {
    personal: {
      branchName: {
        required: helpers.withMessage("Branch Name is required...", required),
      },
      title: {
        required: helpers.withMessage("Title is required...", required),
      },
      surname: {
        required: helpers.withMessage("Surname is required...", required),
      },
      firstName: {
        required: helpers.withMessage("First Name is required...", required),
      },
      middleName: {
        required: helpers.withMessage("Middle Name is required...", required),
      },
      address: {
        required: helpers.withMessage("Address is required...", required),
      },
      address_line: {
        required: helpers.withMessage("Address is required...", required),
      },
      address_line_two: {
        required: helpers.withMessage("Address is required...", required),
      },
      city_name: {
        required: helpers.withMessage("City Name is required...", required),
      },
      state_name: {
        required: helpers.withMessage("State Name is required...", required),
      },
      zip_code: {
        required: helpers.withMessage("Zip Code is required...", required),
      },
      country_name: {
        required: helpers.withMessage(
          "Country Name is required...",
          required,
        ),
      },
      maritalStatus: {
        required: helpers.withMessage("Marital is required...", required),
      },
      dob: {
        required: helpers.withMessage(
          "Date of Birth is required...",
          required,
        ),
      },
      gender: {
        required: helpers.withMessage("Gender is required...", required),
      },
      numOfDependents: {
        required: helpers.withMessage("Dependents is required...", required),
      },
      placeOfdob: {
        required: helpers.withMessage("Place is required...", required),
      },
      nationality: {
        required: helpers.withMessage("Nationality is required...", required),
      },
      nationalIdNum: {
        required: helpers.withMessage(
          "National Id Num is required...",
          required,
        ),
      },
      nidIssueDate: {
        required: helpers.withMessage(
          "NID Issue Date is required...",
          required,
        ),
      },
      nidExpiry: {
        required: helpers.withMessage(
          "NID Expiry Date is required...",
          required,
        ),
      },
      nationalIssuance: {
        required: helpers.withMessage(
          "National Issuance is required...",
          required,
        ),
      },
      drivingIdNum: {
        required: helpers.withMessage("Permit No is required...", required),
      },
      didIssueDate: {
        required: helpers.withMessage("Issue Date is required...", required),
      },
      didExpiry: {
        required: helpers.withMessage("Expiry Date is required...", required),
      },
      driverIssuance: {
        required: helpers.withMessage("Issuance is required...", required),
      },
      passportNum: {
        required: helpers.withMessage("Passport No is required...", required),
      },
      passIssueDate: {
        required: helpers.withMessage("Issue Date is required...", required),
      },
      passExpiry: {
        required: helpers.withMessage(
          "Passport Expiry Date is required...",
          required,
        ),
      },
      passportIssuance: {
        required: helpers.withMessage("Issuance is required...", required),
      },
      birthIdNum: {
        required: helpers.withMessage("Birthday is required...", required),
      },
      birthIssuance: {
        required: helpers.withMessage("Issurance is required...", required),
      },
      homePhoneNum: {
        required: helpers.withMessage(
          "Home Phone No is required...",
          required,
        ),
      },
      mobileNum: {
        required: helpers.withMessage("Mobile No is required...", required),
      },
      email: {
        required: helpers.withMessage("Email is required...", required),
      },
      nidDoc: {
        required: helpers.withMessage("Expiry Date is required...", required),
      },
      employStatus: {
        required: helpers.withMessage("Status is required...", required),
      },
      user_phone_no: {
        required: helpers.withMessage(
          "User Phone No is required...",
          required,
        ),
      },
      user_howlong: {
        required: helpers.withMessage("This is required...", required),
      },
      user_occupation: {
        required: helpers.withMessage("Occupation is required...", required),
      },
      user_w_phone_no: {
        required: helpers.withMessage(
          "Work Phone No is required...",
          required,
        ),
      },
      user_employer: {
        required: helpers.withMessage("Address is required...", required),
      },
      employer: {
        required: helpers.withMessage("Employer is required...", required),
      },
      user_isstudent: {
        required: helpers.withMessage("School is required...", required),
      },
      frequencyStatus: {
        required: helpers.withMessage("Frequency is required...", required),
      },
      averageIncm: {
        required: helpers.withMessage(
          "Monthly Income is required...",
          required,
        ),
      },
      accFunded: {
        required: helpers.withMessage("Fund is required...", required),
      },
      accountActi: {
        required: helpers.withMessage("This is required...", required),
      },
      accountActiDesc: {
        required: helpers.withMessage("This is required...", required),
      },
      numTrans: {
        required: helpers.withMessage("Transaction is required...", required),
      },
      volTrans: {
        required: helpers.withMessage("Transaction is required...", required),
      },
      account_one: {
        required: helpers.withMessage(
          "Account Number is required...",
          required,
        ),
      },
      account_two: {
        required: helpers.withMessage(
          "Account Number is required...",
          required,
        ),
      },
      account_three: {
        required: helpers.withMessage(
          "Account Number is required...",
          required,
        ),
      },
      shares_amount: {
        required: helpers.withMessage("Amount is required...", required),
      },
      special_shares_amount: {
        required: helpers.withMessage("Amount is required...", required),
      },
      deposit_ac_amount: {
        required: helpers.withMessage("Amount is required...", required),
      },
      reg_fee_amount: {
        required: helpers.withMessage("Amount is required...", required),
      },
      total_amount: {
        required: helpers.withMessage("Amount is required...", required),
      },
      appointnominee_name1: {
        required: helpers.withMessage("Name is required...", required),
      },
      appointnominee_pno1: {
        required: helpers.withMessage("Phone No is required...", required),
      },
      appointnominee_rel1: {
        required: helpers.withMessage("Relation is required...", required),
      },
      appointnominee_address1: {
        required: helpers.withMessage("Address is required...", required),
      },
      appointnominee_email1: {
        required: helpers.withMessage("Email is required...", required),
      },
      appointnominee_dob1: {
        required: helpers.withMessage(
          "Date of Birth is required...",
          required,
        ),
      },

      appointnominee_name2: {
        required: helpers.withMessage("Name is required...", required),
      },
      appointnominee_pno2: {
        required: helpers.withMessage("Phone No is required...", required),
      },
      appointnominee_rel2: {
        required: helpers.withMessage("Relation is required...", required),
      },
      appointnominee_address2: {
        required: helpers.withMessage("Address is required...", required),
      },
      appointnominee_email2: {
        required: helpers.withMessage("Email is required...", required),
      },
      appointnominee_dob2: {
        required: helpers.withMessage(
          "Date of Birth is required...",
          required,
        ),
      },
      hereRadioType: {
        required: helpers.withMessage("Required...", required),
      },
      datename8: {
        required: helpers.withMessage("Date is required...", required),
      },
      entrustedRadio: {
        required: helpers.withMessage("Required...", required),
      },
      memberOfRadio: {
        required: helpers.withMessage("Required...", required),
      },
      referredRadio: {
        required: helpers.withMessage("Required...", required),
      },
      tobagoRadio: {
        required: helpers.withMessage("Required...", required),
      },
      citizenRadio: {
        required: helpers.withMessage("Required...", required),
      },
      ssn_no: {
        required: helpers.withMessage("SSN no is  required...", required),
      },
      addressRadio: {
        required: helpers.withMessage("Required...", required),
      },
      incomeUsRadio: {
        required: helpers.withMessage("Required...", required),
      },
      hereRadio1: {
        required: helpers.withMessage("Required...", required),
      },
      trusteeRadioo: {
        required: helpers.withMessage("Required...", required),
      },
      relationbenifit3: {
        required: helpers.withMessage(
          "Relationship is required...",
          required,
        ),
      },
      appointnominee_name3: {
        required: helpers.withMessage("Name is required...", required),
      },
      appointnominee_pno3: {
        required: helpers.withMessage("Phone No is required...", required),
      },
      appointnominee_email3: {
        required: helpers.withMessage("Email is required...", required),
      },
      appointnominee_dob3: {
        required: helpers.withMessage(
          "Date of Birth is required...",
          required,
        ),
      },
      appointnominee_address3: {
        required: helpers.withMessage("Address is required...", required),
      },
    },
  },
};
export default staffReviewValidations;
